import { LightningElement, api, wire } from "lwc";
import { c as classNames } from "tds/chunk_index";
import { EffectAdapter } from "common/effectAdapter";
import { assignedSlotNames } from "common/slot";
import { createTrack } from "common/track";
import { getAssetsUrl, hash } from "common/helpers";
import { getFocusableElements } from "common/a11y";

var assetAvatarPlaceholder =
  "data:image/svg+xml,%3Csvg%20enable-background%3D%22new%200%200%20180%20181%22%20viewBox%3D%220%200%20180%20181%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%2290%22%20cy%3D%2290%22%20fill%3D%22%23f5f5f5%22%20r%3D%2290%22%2F%3E%3Cpath%20d%3D%22m119.7%20144.7c2.1-.8%203.2-1.4%203.2-1.4%2038.1-24.1%2031.9-54.8%2013.7-79.1%208.1-45.7-21.7-21.9-27.8-16.6-17.3-4-34.4-1.3-34.4-1.3-1.5%200-2.9.2-4.3.3-5.8-5.4-34.9-30.4-28.4%2015.4-1%201.2-1.6%202-1.6%202-34.3%2049.3%2014.6%2077.8%2014.6%2077.8.9.4%201.9.8%202.8%201.2-4.5.5-9.9%202.2-14.2%205-2.8%201.8-6.9%204.2-10.4%2012%2015.5%2012.7%2035.4%2020.4%2057%2020.4%2020%200%2038.5-6.5%2053.5-17.6-5.9-12.3-17.1-16.3-23.7-18.1z%22%20fill%3D%22%23e9e9e9%22%2F%3E%3Cpath%20d%3D%22m46.1%2062c-3.4-4.3-2.9-20%203.1-22%201.7-.1%203.3.4%204.7%201.4%200%200%2013%2011.3%206.2%2018-5.9%205.8-11.8%205.4-14%202.6z%22%20fill%3D%22%23dedede%22%2F%3E%3Cpath%20d%3D%22m36.7%2076s-20.9%2038.4%2017.3%2060c0%200-30.2-26-17.3-60z%22%20fill%3D%22%23dedede%22%2F%3E%3Cpath%20d%3D%22m134.9%2047.1c-.4-1.1-.9-2.2-1.6-3.1-.6-.9-1.5-1.5-2.4-1.9h-.1-.1c-.2%200-.4%200-.6%200-.7%200-1.4.1-2%20.2-.9.2-1.7.6-2.4%201.2-1.5%201.3-3%202.8-4.3%204.3-1.1%201.3-2.1%202.8-3%204.3s-1.4%203.2-1.5%205c0%201.9.7%203.7%202%205%203.3%203.5%206.7%205%209.5%205%201.9.1%203.7-.6%205-2%20.9-1.2%201.5-2.6%201.8-4.1.4-1.9.7-3.8.7-5.7.2-2.9-.2-5.6-1-8.2z%22%20fill%3D%22%23dedede%22%2F%3E%3Cpath%20d%3D%22m134%20103.6c.4%2016.1-12%2030.1-29.6%2035.3-4.4%201.3-8.9%202-13.5%202.1-18.9.5-35.2-8.8-41.8-22.4-.2-.4-.4-.8-.5-1.2-1.6-3.6-2.5-7.5-2.6-11.5-.5-20%2019.6-37.3%2043.9-37.9%204.4-.1%208.7.3%2012.9%201.3%2017.9%204.2%2030.7%2018%2031.2%2034.3z%22%20fill%3D%22%23f8f8f8%22%2F%3E%3Cg%20fill%3D%22%23dbdbdb%22%3E%3Cellipse%20cx%3D%2268.5%22%20cy%3D%22115%22%20rx%3D%226.5%22%20ry%3D%224%22%20transform%3D%22matrix%28.07167154%20-.9974%20.9974%20.07167154%20-51.1137%20175.0816%29%22%2F%3E%3Cellipse%20cx%3D%22108.5%22%20cy%3D%22118%22%20rx%3D%226.5%22%20ry%3D%224%22%20transform%3D%22matrix%28.07167154%20-.9974%20.9974%20.07167154%20-16.9729%20217.7637%29%22%2F%3E%3Cpath%20d%3D%22m52.8%20124s-4-25.6%202.4-26.3c0%200%203.3%204.2%205.5%204.2.4%200-1.5-13%205.4-17.1%200%200%2024.8%209.6%2027.6%203.9-.9-.5-10-3.9-9.6-7.9.2-2.2%2019.5-2.1%2028%2016.7%201.4.8%203.6-2.8%204.1-8%20.9-9.7%207.9%2016.3%208.1%2016.7.1.4%202-.6%203.7-3%201.6-2.4%201.1%2015.6.8%2017.5-.3%201.8%206.3-7.7%205.2-19.9s-11.9-25-21.3-28.8c-8.9-3.6-24-10.2-47.1%201.8-24.7%2012.8-18.9%2039-18.8%2039.4.6%203.1%205%2010.6%206%2010.8z%22%2F%3E%3Cpath%20d%3D%22m89.5%20180.5c5.2%200%2010.4-.5%2015.4-1.3-.6-9.1-.7-24.2-17.4-24.2-17.9%200-17.7%2013.7-18.3%2023.2%206.6%201.5%2013.3%202.3%2020.3%202.3z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

/**
 * This utility exists because <ui-focus-trap> has some weird issues
 * with default <slot> content
 */

function trapFocus(element) {
  let focusFirst = () =>
    getFocusableElements(element)
      .slice(0, 1)
      .forEach((n) => n.focus());

  let focusLast = () =>
    getFocusableElements(element)
      .slice(-1)
      .forEach((n) => n.focus());

  let onKeyDown = (e) => {
    if (e.key === "Tab") {
      let [target] = e.composedPath();
      let elements = getFocusableElements(element);

      if (target.contains(elements[0]) && e.shiftKey) {
        e.preventDefault();
        focusLast();
      }

      if (target.contains(elements[elements.length - 1]) && !e.shiftKey) {
        e.preventDefault();
        focusFirst();
      }
    }
  };

  element.addEventListener("keydown", onKeyDown);
  setTimeout(focusFirst);
  return () => {
    element.removeEventListener("keydown", onKeyDown);
  };
}

class headerMobile extends LightningElement {
  @api apps = null;
  @api help = null;
  @api labels = {};
  @api logo = null;
  @api navItems = null;
  @api user = null;
  @api signinLink = null;
  @api signupLink = null;
  @api inboxNotification;
  slots = "";
  track = createTrack(this);

  get assets() {
    return {
      avatarPlaceholder: getAssetsUrl(assetAvatarPlaceholder),
    };
  }

  get navSections() {
    let navItems = this.navItems || [];
    return [navItems]
      .concat(this.userNavSections)
      .filter((section) => section.length > 0)
      .map((items) => ({
        items,
        key: hash(items.map((i) => i.label).join("")),
      }));
  }

  get section1ClassName() {
    return classNames("section-1", {
      "section-1--show-menu": this.showMenuButton,
    });
  }

  get showMenuButton() {
    return this.user || this.navItems;
  }

  get userNavSections() {
    try {
      return [
        this.user.navItems.filter((i) => i.mobile === true),
        [this.user.logout],
      ];
    } catch {
      return [];
    }
  }

  open = false;
  removeFocusTrap = undefined;

  handleAppLauncherTrack(e) {
    let eventName = e.detail.eventName;
    let name = `app_launcher_${eventName}`;
    this.track(name, e.detail.payload);
  }

  handleHelpButtonClick() {
    this.track("help_clicked", undefined);
  }

  handleLogoClick() {
    this.track("logo_clicked", undefined);
  }

  handleNavTrack(e) {
    let eventName = e.detail.eventName;
    let name = `nav_${eventName}`;
    this.track(name, e.detail.payload);
  }

  handleProfileTrack(e) {
    let eventName = e.detail.eventName;
    let name = `profile_${eventName}`;
    this.track(name, e.detail.payload);
  }

  handleSigninClick() {
    this.track("signin_clicked", {
      label: this.labels.logIn,
    });
  }

  handleSignupClick() {
    this.track("signup_clicked", {
      label: this.labels.signUp,
    });
  }

  handleInboxNotificationClick() {
    this.track("community_inbox_clicked", {
      label: this.labels.messages,
    });
  }

  onMenuClick() {
    this.open = true;
    this.dispatchEvent(
      new CustomEvent("trailhead_mobile_menu_opened", {
        bubbles: true,
        composed: true,
      })
    );
  }

  onMenuCloseClick() {
    this.open = false;
    this.dispatchEvent(
      new CustomEvent("trailhead_mobile_menu_closed", {
        bubbles: true,
        composed: true,
      })
    );
  }

  get userStats() {
    if (this.user && this.user.currentRank) {
      return this.labels.userStatsWithRank;
    }

    return this.labels.userStats;
  }

  @wire(EffectAdapter, {
    open: "$open",
  })
  onOpen() {
    document.body.style.overflow = this.open ? "hidden" : "";
  }

  onSlotChange() {
    this.slots = assignedSlotNames(this.template).join(" ");
  }

  renderedCallback() {
    if (this.open && !this.removeFocusTrap) {
      this.removeFocusTrap = trapFocus(this.template.querySelector(".menu"));
    }

    if (!this.open && this.removeFocusTrap) {
      this.removeFocusTrap();
      this.removeFocusTrap = undefined;
    }
  }
}

export default headerMobile;
